import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarFive = _resolveComponent("NavbarFive")!
  const _component_ResponsiveNavbar = _resolveComponent("ResponsiveNavbar")!
  const _component_PageBanner = _resolveComponent("PageBanner")!
  const _component_ContactInfo = _resolveComponent("ContactInfo")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_DownloadTheApp = _resolveComponent("DownloadTheApp")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarFive, { class: "home_one" }),
    _createVNode(_component_ResponsiveNavbar, { class: "home_one" }),
    _createVNode(_component_PageBanner, {
      pageTitle: "Contact Us",
      mainTitle: "Contact Us"
    }),
    _createVNode(_component_ContactInfo),
    _createVNode(_component_ContactForm),
    _createVNode(_component_DownloadTheApp),
    _createVNode(_component_MainFooter)
  ], 64))
}